// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__7PhLJ","description":"PatientConsentPreview_description__2w7sx"};